<template>
  <div class="container">
    <div class="content" v-if="pageType === 'unsubscribe'">
      <p>{{$t('unsubscribe_title')}}</p>
      <div @click="unsubscribe" :class='{"disabled": isDisabled}'>{{$t('unsubscribe_button')}}</div>
    </div>
    <div class="content" v-if="pageType === 'resubscribe'">
      <p>{{$t('resubscribe_title')}}</p>
      <div @click="resubscribe" :class='{"disabled": isDisabled}'>{{$t('resubscribe_button')}}</div>
    </div>
    <div class="content restored" v-if="pageType === 'restored'">
      <p>{{$t('restored_title')}}</p>
    </div>
  </div>
</template>

<script>
  import locales from './lang'

  export default {
    name: 'subscribe-manage',
    locales,
    data: function () {
      return {
        pageType: 'unsubscribe',
        emailType: '',
        token: '',
        isDisabled: false
      }
    },
    mounted: function () {
      const {type, token, lang} = this.$route.query
      lang && this.$store.commit('setCurrentLang', lang.split('-')[0])
      this.emailType = type
      this.token = token
    },
    methods: {
      unsubscribe: function () {
        if (this.isDisabled) {
          return null
        }
        this.isDisabled = true
        this.$http.post(`api/email/unsubscribe?type=${this.emailType}&token=${this.token}`)
        .then((response) => {
          this.isDisabled = false
          if (response.data.message === 'success') {
            this.pageType = 'resubscribe'
          }
        }, () => {
          this.isDisabled = false
        })
      },
      resubscribe: function () {
        if (this.isDisabled) {
          return null
        }
        this.isDisabled = true
        this.$http.post(`api/email/subscribe?type=${this.emailType}&token=${this.token}`)
        .then((response) => {
          this.isDisabled = false
          if (response.data.message === 'success') {
            this.pageType = 'restored'
          }
        }, () => {
          this.isDisabled = false
        })
      }
    }
  }
</script>

<style rel="stylesheet/scss" lang="scss" scoped>
  .container {
    background: #f8f8f8;
    width: 100%;
    margin-top: 1px;
    height: 65vh;
    min-height: 500px;
    position: relative;
  }
  .content {
    position: absolute;
    top: 20%;
    left: 50%;
    transform: translateX(-50%);
    width: 440px;
    min-height: 200px;
    background: #416CF8;
    border-radius: 8px;
    padding: 40px;
    box-sizing: border-box;
    color: #fff;
    text-align: center;
    display: flex;
    flex-flow: column;
    justify-content: space-between;
    align-items: center;
    @media screen and (max-width: 767px) {
      max-width: 3.35rem;
    }
    p {
      font-size: 18px;
      margin: 0;
      text-align: left;
    }
    div {
      width: 170px;
      height: 40px;
      line-height: 40px;
      border: 1px solid #fff;
      border-radius: 26px;
      font-size: 16px;
      margin: 20px auto 0;
      cursor: pointer;
      &.disabled {
        opacity: .3;
      }
    }
    &.restored {
      justify-content: center;
    }
  }
</style>


// WEBPACK FOOTER //
// subscribeManage.vue?1f9a1b37